import api from './apiData.js'

const getMenusEndpoint = "api/menus/?nutritionist=";
const getMenuListEndpoint = "api/menus/";
const generateMenuEndpoint = "api/menu";

export default {

  getMenus(nutId){
    return api.get( getMenusEndpoint+`${nutId}`);
  },
  getMenuList(){
    return api.get( getMenuListEndpoint);
  },
  generateMenu(body){
    return api.post( generateMenuEndpoint, body);
  }
}
